export function getResearchDomain(url?: string) {
  if (location.host === 'test.alfagpt.org') {
    if (!url) {
      return `https://gpt.modelingai.com`;
    }
    if (url.startsWith('http')) {
      return url;
    }
    return `https://gpt.modelingai.com/${url}`;
  } else {
    if (!url) {
      return process.env.NEXT_PUBLIC_RESEARCH_DOMAIN || `https://gpt.modelingai.com`;
    }
    if (url.startsWith('http')) {
      return url;
    }
    return `${process.env.NEXT_PUBLIC_RESEARCH_DOMAIN || `https://gpt.modelingai.com`}/${url}`;
  }
}
